import styled from 'styled-components'
import { Box, Icon, Typography } from '@mui/material'
import ScheduleIcon from '@mui/icons-material/Schedule'
import FlagIcon from '@mui/icons-material/Flag'
import { ArrowForwardIosRounded } from '@mui/icons-material'
import { Link } from 'react-router-dom'

// const StyledTileDiv = styled.div`
//   text-align: center;
//   position: relative;
//   padding: 16px;
//   height: 100%;
//   cursor: pointer;
//   border: 2px solid #f1f1f1;
//   background: ${(props) => (props.active ? '#0671ad' : 'transparent')};
//   color: ${(props) =>
//     props.active ? '#fff !important' : '#344767 !important'};
//   border-radius: 0.75rem;
//   transition: 0.2s transform ease-in-out;
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   &.no-click {
//     pointer-events: none;
//   }
//   &.textWithDescription {
//     align-items: flex-start;
//     background: ${(props) => (props.active ? '#F9F9F9' : 'transparent')};
//     border: ${(props) =>
//       props.active ? '2px solid #a3a7aa' : '2px solid #f1f1f1'};
//     color: #344767 !important;
//     > h6,
//     h5 {
//       color: #344767;
//       line-height: 1.625;
//     }
//   }
//   &:hover {
//     transition: 0.2s all ease-in-out;
//     border: 2px solid #a3a7aa;
//     transform: scale(1.02);
//     background: ${(props) => (props.active ? '#0671ad' : '#f9f9f9')};
//     color: ${(props) => (props.active ? '#fff' : '#344767')};
//     > h6,
//     h5 {
//       color: ${(props) => (props.active ? '#fff' : '#344767')};
//     }
//     > span {
//       background-color: ${(props) => (props.active ? '#044F79' : '#f1f1f1')};
//       color: ${(props) => (props.active ? '#fff' : '#5d6d8e')};
//     }
//   }
//   &.textWithDescription:hover {
//     transition: 0.2s all ease-in-out;
//     border: 2px solid #a3a7aa;
//     background: ${(props) => (props.active ? '#F9F9F9' : '#F9F9F9')};
//     color: #344767 !important;
//     > h6,
//     h5 {
//       color: #344767;
//     }
//   }
//   > h6,
//   h5 {
//     color: ${(props) => (props.active ? '#fff' : '#344767')};
//     letter-spacing: 0.3px;
//     font-weight: 500;
//     line-height: 1.4;
//     margin-top: 8px;
//     &:only-child {
//       margin-top: 0px;
//     }
//   }
//   *.option-badge {
//     background-color: #f0f4f8;
//     color: #3498db;
//     font-size: 14px;
//     padding: 6px 10px;
//     margin-left: 20px;
//     border-radius: 4px;
//     text-transform: uppercase;
//     &.error {
//       color: #d32f2f;
//       background-color: #fdeded;
//     }
//   }
//   > span {
//     background-color: ${(props) => (props.active ? '#044F79' : '#f9f9f9')};
//     border-radius: 50%;
//     color: ${(props) => (props.active ? '#fff' : '#5d729e')};
//     height: 1.5em;
//     width: 1.5em;
//     padding: 8px;
//     &.yesIcon {
//       color: #4caf50;
//       background-color: #dbefdc;
//     }
//     &.noIcon {
//       color: #fd5c70;
//       background-color: #fedee2;
//     }
//   }
//   .alert-style {
//     color: #fd5c70;
//   }
// `

const StyledTileDiv = styled.div`
  text-align: center;
  position: relative;
  padding: 16px;
  height: 100%;
  cursor: pointer;
  border: ${(props) =>
    props.active ? '2px solid #a3a7aa' : '2px solid #f1f1f1'};
  background: ${(props) => (props.active ? '#eeeeee' : '#fff')};
  color: #212121;
  border-radius: 0.75rem;
  transition: 0.2s all ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &:hover {
    border: ${(props) =>
      props.active ? '2px solid #a3a7aa' : '2px solid #d1d3d4'};
    background: ${(props) => (props.active ? '#f5f5f5' : '#fdfdfd')};
  }

  &.textWithDescription {
    align-items: flex-start;
    background: ${(props) => (props.active ? '#eeeeee' : '#fff')};
    border: ${(props) =>
      props.active ? '2px solid #a3a7aa' : '2px solid #f1f1f1'};
    color: #212121 !important;
    > h6,
    h5 {
      color: #212121;
      line-height: 1.625;
      text-align: left;
    }
  }
  &.textWithDescription:hover {
    transition: 0.2s all ease-in-out;
    border: ${(props) =>
      props.active ? '2px solid #a3a7aa' : '2px solid #d1d3d4'};
    background: ${(props) => (props.active ? '#f5f5f5' : '#fdfdfd')};
    color: #212121 !important;
    > h6,
    h5 {
      color: #212121;
    }
  }
  *.option-badge {
    background-color: #f0f4f8;
    color: #3498db;
    font-size: 14px;
    padding: 6px 10px;
    margin-left: 20px;
    border-radius: 4px;
    text-transform: uppercase;
    &.error {
      color: #d32f2f;
      background-color: #fdeded;
    }
  }

  > div > div > h6,
  h5 {
    color: #212121;
    letter-spacing: 0.3px;
    font-weight: 600;
    line-height: 1.4;
    margin: 0;
  }

  > div > div > span {
    border-radius: 50%;
    height: 1.5em;
    width: 1.5em;
    padding: 8px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.yesIcon {
      color: #4caf50;
      background-color: #dbefdc;
    }
    &.noIcon {
      color: #fd5c70;
      background-color: #fedee2;
    }
  }
`

const StyledTileLogo = styled.img`
  max-height: 80px;
  width: auto;
  max-width: 100%;
`

export const OnboardingTile = ({
  active,
  onClick,
  icon,
  imageURL,
  label,
  className,
  optionDescription,
  optionTimer,
  optionLabelBadge,
  optionLabelBadgeType,
  optionAdditionalContent,
  optionTimerClass,
  optionTimerIcon,
  optionLink,
  iconClassName,
  arrowIndicator,
}) => {
  const tileContent = (
    <StyledTileDiv active={active} onClick={onClick} className={className}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          justifyContent:
            className === 'textWithDescription' ? 'space-between' : 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems:
              className === 'textWithDescription' ? 'flex-start' : 'center',
          }}
        >
          {icon && (
            <Icon className={iconClassName} fontSize="large">
              {icon}
            </Icon>
          )}
          {imageURL && <StyledTileLogo src={imageURL} />}
          <Typography
            variant={className === 'textWithDescription' ? 'h5' : 'h6'}
          >
            {label}
            {optionLabelBadge ? (
              <span className={`option-badge ${optionLabelBadgeType}`}>
                {optionLabelBadge}
              </span>
            ) : (
              <></>
            )}
          </Typography>
          {className === 'textWithDescription' ? (
            <>
              <Typography variant="body2" pt={1} textAlign={'left'}>
                {optionDescription}
              </Typography>
              {optionAdditionalContent}
              {optionTimer && (
                <Typography
                  variant="body2"
                  pt={1}
                  textAlign={'left'}
                  className={optionTimerClass || ''}
                >
                  {optionTimerClass === 'alert-style' ? (
                    <FlagIcon
                      sx={{ marginBottom: '-2px', marginRight: '5px' }}
                    />
                  ) : (
                    <>
                      {optionTimerIcon ? (
                        optionTimerIcon
                      ) : (
                        <ScheduleIcon
                          sx={{ marginBottom: '-2px', marginRight: '5px' }}
                        />
                      )}
                    </>
                  )}

                  {optionTimer}
                </Typography>
              )}
            </>
          ) : (
            <></>
          )}
        </Box>
        {arrowIndicator && (
          <Box sx={{ marginLeft: '24px' }}>
            <ArrowForwardIosRounded />
          </Box>
        )}
      </Box>
    </StyledTileDiv>
  )
  return optionLink ? (
    <Link to={optionLink} style={{ textDecoration: 'none' }}>
      {tileContent}
    </Link>
  ) : (
    tileContent
  )
}
